/**
 * Web-only context helper for error log enrichment.
 *
 * Lives outside `apps/web/src/logger.ts` so the ErrorBoundary can
 * import the same function — single source of truth for "what env
 * fields do we attach on web?".
 *
 * Spec: docs/superpowers/specs/2026-05-18-error-logging-enrichment-design.md
 */
export function buildWebContext(extra?: Record<string, unknown>): Record<string, unknown> {
  return {
    pathname: window.location.pathname,
    search: window.location.search || undefined,
    online: navigator.onLine,
    visibility: document.visibilityState,
    ...extra,
  }
}
